import { render, staticRenderFns } from "./ManageDrug.vue?vue&type=template&id=fc385d70&scoped=true&"
import script from "./ManageDrug.vue?vue&type=script&lang=js&"
export * from "./ManageDrug.vue?vue&type=script&lang=js&"
import style0 from "./ManageDrug.vue?vue&type=style&index=0&id=fc385d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc385d70",
  null
  
)

export default component.exports